import { Reveal, Eyebrow } from "../components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Is a living trust really different from a will?",
    a: "Yes. A will only activates at death and still drags your family through probate court. A living trust works for you while you are alive, keeps everything out of court, and passes what you built to your family without delay.",
  },
  {
    q: "Do I have to pay anything before I see my trust?",
    a: "No. You go through the portal at your own pace and see everything set up first. Before anything finalizes, before you pay a single dollar, I personally call you and answer every question. You only move forward when you are completely satisfied.",
  },
  {
    q: "How long does the process take?",
    a: "The portal takes about 20 to 30 minutes to complete at your own pace. Once you are ready and we have spoken personally, your completed trust is released to you and your protection is in place from that day.",
  },
  {
    q: "Is the legal review really included at no extra charge?",
    a: "Yes. Through my veteran military legal benefits, every file I take on receives a legal review by a licensed attorney at no additional charge. Available based on your location. It is built into everything I do.",
  },
  {
    q: "What is the difference between the Basic and Private trust?",
    a: "Both protect you. The Basic Trust at $1,497 is legally valid, avoids probate, and fully protects your assets, but it is on public record. The Private Trust at $2,497 is completely invisible with no public record. You can start basic now and upgrade to private for $1,000 more when you are ready.",
  },
  {
    q: "I already have a trust. Should I still reach out?",
    a: "Yes. Most trusts are either sitting empty, missing key protections, or were written under laws that have since changed. Bring it to me and I will review it at no cost. No commitment. Just answers.",
  },
];

export const FAQ = () => (
  <section className="bg-inkdeep py-24 sm:py-36" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Common Questions</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.06] mt-6">
          Before You Start, <em className="text-gold italic">Ask Away.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15} className="mt-12 sm:mt-16">
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-surface border border-white/8 rounded-xl px-6 sm:px-8 data-[state=open]:border-gold/40 transition-colors duration-400"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="font-display text-lg sm:text-xl text-cream text-left hover:no-underline hover:text-gold py-6 [&>svg]:text-gold"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-cream/65 leading-relaxed text-sm sm:text-base pb-7">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
